module.exports = __webpack_public_path__ + "static/media/logo.bf879800.png";